"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSlicePrimaryWidget = exports.SlicePrimaryWidget = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const Group_1 = require("../Group");
const nestable_1 = require("../nestable");
exports.SlicePrimaryWidget = t.union([nestable_1.NestableWidget, Group_1.Group]);
const isSlicePrimaryWidget = (u) => nestable_1.NestableWidget.is(u) || Group_1.Group.is(u);
exports.isSlicePrimaryWidget = isSlicePrimaryWidget;
